import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'

import type { WithSnackbarMessages } from '../../actions/index.types'
import { CheckboxMenuSelectedItem } from '../CheckboxMenuSelectedItem/CheckboxMenuSelectedItem'
import type { CheckboxMenuItemLike } from '../index.types'

type Props<Data extends Record<string, unknown>> = CheckboxMenuItemLike & {
  onDelete: (items: Data[]) => Promise<void> | void
  renderItem: (item: Data) => React.ReactNode | string
  confirmationTitle?: string
  confirmationMessage?: string
  disabled?: boolean
} & WithSnackbarMessages<Data[]>

/** Component to be used as a base for creating new CheckboxDeleteSelectedItems if messages need to be overwritten. NOT for standalone use (eg. CheckboxDeleteSelectedTranscoderItems) */
export const CheckboxDeleteSelectedItem = <Data extends Record<string, unknown>>({
  onDelete,
  renderItem,
  successMessage = 'Items deleted successfully',
  errorMessage = 'Failed to delete items',
  confirmationTitle = 'Delete Selected Items',
  confirmationMessage = 'Are you sure you want to delete the following items? This action cannot be undone.',
  disabled = false
}: Props<Data>) => (
  <CheckboxMenuSelectedItem
    onAction={onDelete}
    renderItem={renderItem}
    successMessage={successMessage}
    errorMessage={errorMessage}
    confirmationTitle={confirmationTitle}
    confirmationMessage={confirmationMessage}
    disabled={disabled}
    actionLabel="Delete"
    icon={<DeleteOutlineOutlinedIcon />}
  />
)
